import React, { useRef, useState } from "react";

const ExplainCard = ({ text, image, alt, index }) => {
  return (
    <div className="bg-[#F3EDF9] rounded-xl h-full">
      <div className="flex flex-col items-center justify-start text-center gap-2 sm:gap-3 px-3 py-6 h-full">
        <img
          src={image}
          alt={alt}
          loading="lazy"
          className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-contain"
        />
        <div className="flex flex-col items-center justify-start text-center flex-1">
          <p className="font-bold text-black text-[16px] sm:text-[18px] md:text-[20px] leading-none">{index}.</p>
          <p className="font-bold text-center w-[90%] break-words leading-snug text-[14px] sm:text-[16px] md:text-[18px]">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
};

const cardData = [
  {
    des: "Faster emergency response",
    image: "/Assets/Images/FasterEmergencyResponse.svg",
    alt: "Purple line icon of a medical emergency alert bell with a cross and warning lines, representing fast response."
  },
  {
    des: "Enhances safety in public spaces",
    image: "/Assets/Images/SafetyInPublicSpaces.svg",
    alt: "Purple line icon of hands holding up a heart with a medical cross inside, symbolizing safety and protection."
  },
  {
    des: "Supports all age groups & disabilities/illnesses",
    image: "/Assets/Images/AgeGroupDisability.svg",
    alt: "Purple line icon of three human figures: a child, an adult, and a senior with a walking stick."
  },
  {
    des: "Customisable for your needs ",
    image: "/Assets/Images/CustomiseNeeds.svg",
    alt: "Purple line icon of a checklist with three tick marks, representing customization."
  },
  {
    des: "Promotes inclusion & awareness",
    image: "/Assets/Images/InclusionAndAwareness.svg",
    alt: "Purple line icon of three human figures standing together with a heart above them, symbolizing inclusion."
  },
  {
    des: "Maintains independence & dignity",
    image: "/Assets/Images/IndependenceAndDiginity.svg",
    alt: "Purple line icon of two hands shaking below a heart with a checkmark, symbolizing independence and dignity."
  }
];

const KeyBenefitsSection = () => {
  const iframeRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    const command = isMuted ? "unMute" : "mute";
    iframeRef.current?.contentWindow?.postMessage(
      JSON.stringify({
        event: "command",
        func: command,
        args: [],
      }),
      "*"
    );
    setIsMuted(!isMuted);
  };

  return (
    <>
      <section className="flex flex-col md:flex-row justify-between items-end gap-8 md:gap-20 w-full md:px-20 px-4">
        <div className="w-full md:w-1/2">
          <h2
            className="mb-6 text-[#118B91] font-bold text-[1.5rem]"
          >
            What is the use ?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full items-stretch">
            {cardData.map((allData, idx) => {
              return (
                <ExplainCard
                  text={allData.des}
                  alt={allData.alt}
                  image={allData.image}
                  index={idx + 1}
                  key={allData.des}
                />
              );
            })}
          </div>
        </div>
        <div className="w-full h-full md:w-1/2 flex items-center">
          <div className="w-full aspect-video">
            <video 
              controls
              autoPlay
              muted
              playsInline
              className="w-full h-full object-cover rounded-xl"
              src="/Assets/Videos/PSLDemoVideo.mp4"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>
    </>
  );
};

export default KeyBenefitsSection;